import { currentAccessToken } from "../catalog/admin-runtime";
import { getAdminPublicConfig } from "../config/public-config";
import { createHttpCopilotApi } from "../copilot/api";
import { createHttpConversationsApi } from "./api";
import type { ConversationsRuntime } from "./runtime";

/**
 * The runtime of the real admin app: the typed API over `fetch` and the real Stream connector. The bearer token comes from the same
 * function the catalog and the memory pages use. The public Stream key is NOT configured here: it comes from the session route.
 */
export function createAdminConversationsRuntime(): ConversationsRuntime {
  const config = getAdminPublicConfig();
  return {
    api: createHttpConversationsApi({
      baseUrl: config.apiUrl.toString(),
      getAccessToken: currentAccessToken,
    }),
    copilot: createHttpCopilotApi({
      baseUrl: config.apiUrl.toString(),
      getAccessToken: currentAccessToken,
    }),
    // The Stream SDK is loaded when the first thread needs it, so the rest of the console does not carry it.
    connectMessaging: async (input) =>
      (await import("./stream-adapter")).createStreamConnector()(input),
    now: () => new Date(),
    newId: () => globalThis.crypto.randomUUID(),
  };
}
